module.exports = __webpack_public_path__ + "img/shouquan-hover.67004ff7.png";